import React, { useState } from "react";
import AdminNavigation from "../AdminNavigation";
import { API_BASE_URL } from "../../..";
const UploadImage = () => {
  const [file, setFile] = useState(null);
  const [uploadedId, setUploadedId] = useState("");

  const handleChange = (e) => {
    const selected = e.target.files[0];
    setFile(selected);
  };

  const handleUpload = () => {
    if (!file) return;
    const formData = new FormData();
    formData.append("image", file);
    fetch(`${API_BASE_URL}rest/admin/images/upload`, {
      method: "POST",
      body: formData,
      credentials: "include",
    })
      .then((res) => res.text())
      .then((id) => {
        setUploadedId(id);
      });
  };

  return (
    <div className="v2_container">
      <div className="row">
        <AdminNavigation className="col-xl-2 col-lg-3 col-md-4 col-6" />
        <div className="col-xl-10 col-lg-9 col-md-8 col-6 p-l-15">
          <div className="row">
            <h2>Upload Image</h2>
            <input
              type="file"
              accept="image/jpeg,image/jpg,image/png"
              onChange={handleChange}
              style={{ margin: "10px" }}
            />
          </div>
          <div className="row">
            <button onClick={handleUpload}>Upload</button>
            {uploadedId && <div>Uploaded! ID: {uploadedId}</div>}
          </div>
        </div>
      </div>
    </div>
  );
};
export default UploadImage;



// WEBPACK FOOTER //
// ./src/mi-app/adminPanel/Content Management/UploadImage.js